import { storeToRefs } from 'pinia'

import { useUiStore } from '~/store/modules/ui'

interface UseAccount {
  basicAuthEnabled: boolean
  cookieDomain: string
  authPollingInterval: number
  accountSubdomain: string
  basicAuthHeaders: Record<string, string>
  getAccountUrl: (path?: string) => string
}

const useAccount = (): UseAccount => {
  const uiStore = useUiStore()

  const { accountEnv } = storeToRefs(uiStore)

  const values = {
    basicAuthEnabled: !!accountEnv.value.ENABLE_BASIC_AUTH,
    cookieDomain: accountEnv.value.COOKIE_DOMAIN,
    authPollingInterval: Number(accountEnv.value.AUTH_POLLING_INTERVAL),
    accountSubdomain: accountEnv.value.ACCOUNT_SUBDOMAIN,
    basicAuthHeaders: { ... accountEnv.value.BASIC_AUTH_HEADERS },
  }

  const getAccountUrl = (path?: string): string => {
    if (path && values.accountSubdomain) {
      return `${values.accountSubdomain}/${path}`
    }

    if (!path) {
      return values.accountSubdomain
    }

    return path
  }

  return {
    ...values,
    getAccountUrl,
  }
}

export default useAccount
